import type { IconName } from '@/components/ui/Icon';

/*
 * Règles d'écriture de la maquette, valables pour tout `src/content/` :
 * pas de point médian ni de tiret long (virgule, deux-points ou retour à la
 * ligne), et aucune mention de lieu.
 */

export const site = {
  name: 'AICECAP',
  domain: 'aicecap.ch',
  url: 'https://aicecap.ch',
  /** Signature de la charte v2 (couverture, § 09). */
  tagline: "Rien n'est publié qui n'ait tourné",
  description:
    "Une série construite autour d'un seul projet : un pipeline de veille qui collecte, trie et résume l'actualité IA, infrastructure et sécurité. Chaque épisode ajoute un outil, le fait tourner, mesure ce qu'il apporte, et se termine par un verdict.",
  /** Phrase du pied de page. */
  pitch: 'Un projet, une série. Un épisode par mois, un Relevé par semaine.',
  email: 'bonjour@aicecap.ch',
} as const;

/** Navigation principale (en-tête). La série se rejoint depuis l'accueil et le pied de page. */
export const navigation = [
  { label: 'Accueil', to: '/' },
  { label: 'Blog', to: '/blog' },
  { label: 'À propos', to: '/a-propos' },
] as const;

/** Navigation du pied de page. */
export const footerNavigation = [
  { label: 'Accueil', to: '/' },
  { label: 'Blog', to: '/blog' },
  { label: 'La série', to: '/serie' },
  { label: 'À propos', to: '/a-propos' },
] as const;

export type Social = {
  id: string;
  label: string;
  icon: IconName;
  /** Identifiant affiché sur la page À propos. */
  handle: string;
  /** Ce qu'on y trouve, en quelques mots. */
  blurb: string;
  /**
   * Adresse du compte. Vide tant qu'elle n'est pas fournie : le lien pointe
   * alors sur `#`, comme dans la maquette (« À brancher »).
   */
  url: string;
};

export const socials: Social[] = [
  { id: 'youtube', label: 'YouTube', icon: 'youtube', handle: '@aicecap', blurb: 'Les démos brutes', url: '' },
  { id: 'linkedin', label: 'LinkedIn', icon: 'linkedin', handle: '@aicecap', blurb: 'Un post par épisode', url: '' },
  { id: 'instagram', label: 'Instagram', icon: 'instagram', handle: '@aicecap', blurb: 'Les coulisses du labo', url: '' },
  { id: 'github', label: 'GitHub', icon: 'github', handle: 'github.com/aicecap', blurb: 'Un repo par phase', url: '' },
];

export const socialHref = (social: Social): string => social.url || '#';
